

import React, { useState } from "react";
import {
  Typography,
  Dialog,
  DialogContent,
  Button,
  Box,
  IconButton,
  DialogContentText,
  DialogTitle,
  Grid,
  DialogActions,
} from "@material-ui/core";
import { SUPPORTED_WALLETS } from "src/connectors";

import { IoClose } from "react-icons/io5";

export default function ConnectModal({ user, open, setOpen, account }) {
  return (
    <Dialog open={open} onClose={() => setOpen()} fullWidth maxWidth={"xs"}
      style={{ zIndex: 1300 }}
      PaperProps={{ style: { backgroundColor: "#ffffff", color: "#000000" } }}
    >
      <IconButton
        onClick={() => setOpen()}
        style={{ position: "absolute", right: "0", zIndex: 1301 }}
      >
        <IoClose style={{ color: "rgba(0, 0, 0, 0.6)" }} />
      </IconButton>
      <DialogTitle id="alert-dialog-title" style={{ padding: "16px 18px 0px" }}>
        <Typography variant="h5" style={{ color: "#000", marginTop: "20px" }}>
          Connect your Wallet
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Typography
            variant="body2"
            style={{
              marginBottom: "25px",
              color: "rgba(0, 0, 0, 0.6)",
              fontSize: "12px",
            }}
          >
            Please connect a wallet to continue your purchase
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box mb={4} mt={1} style={{ width: "100%" }}>
          <Grid container spacing={2}>
            {SUPPORTED_WALLETS.map((item, i) => {
              return (
                <Grid item xs={12} md={6}>
                  <Box
                    className="connectwalletBox displayCenter"
                    key={i}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (account) {
                        user.disconnectWallet();
                        localStorage.removeItem("walletName");
                      } else {
                        user.connectWallet(item.data);
                      }
                    }}
                  >
                    <img src={item.data.iconName} alt="Trust Wallet" />
                  </Box>
                </Grid>
              );
            })}
          </Grid>
          {/* <Box mt={2}>
            <Button
              onClick={() => user.connectWallet()}
              color="primary"
              variant="contained"
              fullWidth
            >
              Connect
            </Button>
          </Box> */}
        </Box>
      </DialogActions>
    </Dialog>
  );
}
